import styled from "styled-components";

const StyledProduct = styled.div`
    padding: 2% 5%;
    margin: auto;
`;

export default StyledProduct;
